import {DEFAULT_FILTER_PRIORITY} from '@github-ui/filter'
import {BaseUserFilterProvider} from '@github-ui/filter/providers'
import {PersonIcon} from '@primer/octicons-react'

export class UserFilterProvider extends BaseUserFilterProvider {
  constructor() {
    super(
      {
        displayName: 'User',
        key: 'user',
        icon: PersonIcon,
        description: 'Specify the user',
        priority: DEFAULT_FILTER_PRIORITY,
      },
      {
        showAtMe: false,
        includeBots: true,
      },
      {
        filterTypes: {
          exclusive: false,
          valueless: false,
          hasValue: false,
          multiKey: false,
          multiValue: false,
        },
      },
    )
  }
}
